module.exports = __webpack_public_path__ + "img/sora_logo.3f2e8b22.gif";